export const CONCEPT_STRATEGIES = [
  {
    id: "primary",
    rank: "Concept Generated",
    name: "6-Bed HMO Conversion",
    confidence: "High Confidence",
    tone: "positive",
    metrics: {
      valuePotential: "High",
      incomePotential: "Strong (+£2k+ pcm)",
      complexity: "Medium",
      complexityTone: "warning",
      timeToExecute: "12-16 Weeks",
    },
    valueAddLogic: [
      "Convert 2 reception rooms into en-suite bedrooms",
      "Relocate kitchen to rear extension",
      "Upgrade to high-end co-living standard",
    ],
    developmentAngle: {
      works: "Heavy Refurbishment",
      planning: "Sui Generis planning required (Article 4 area)",
    },
    whyThisWorks: [
      "Strong demand for professional HMOs in this postcode",
      "Existing footprint supports 6 rooms without major structural changes",
    ],
    risks: ["Planning risk due to Article 4 directive"],
  },
  {
    id: "alternative",
    rank: "Concept Generated",
    name: "Serviced Accommodation (SA)",
    confidence: "Medium Confidence",
    tone: "warning",
    metrics: {
      valuePotential: "Medium",
      incomePotential: "Strong (+£2k+ pcm)",
      complexity: "High",
      complexityTone: "destructive",
      timeToExecute: "4-6 Weeks",
    },
    valueAddLogic: [
      "Light cosmetic refresh throughout",
      "Furnish to premium short-let standard",
      "List on Airbnb / Booking.com",
    ],
    developmentAngle: {
      works: "Light Refurb & Furnishing",
      planning: "Check lease / local restrictions on short lets",
    },
    whyThisWorks: [
      "Proximity to hospital/business park drives corporate bookings",
      "Minimal capital expenditure required compared to HMO",
    ],
    risks: [
      "Higher operational intensity and void risk",
      "Regulatory changes around short-term lets",
    ],
  },
  {
    id: "conservative",
    rank: "Concept Generated",
    name: "Standard BTL (Single Let)",
    confidence: "High Confidence",
    tone: "positive",
    metrics: {
      valuePotential: "Low",
      incomePotential: "Light (<£1k pcm)",
      complexity: "Low",
      complexityTone: "positive",
      timeToExecute: "2-4 Weeks",
    },
    valueAddLogic: [
      "Basic redecoration (paint & carpets)",
      "Update EPC to band C minimum",
      "Let to single family unit",
    ],
    developmentAngle: {
      works: "Light Refurbishment",
      planning: "Existing C3 use class",
    },
    whyThisWorks: [
      "Safest exit strategy with guaranteed tenant demand",
      "Easiest to finance via standard BTL mortgage",
    ],
    risks: [],
  },
]

export const FEEDBACK_REASONS = [
  "Not physically feasible",
  "Planning unlikely",
  "Doesn't match property layout",
  "Doesn't fit my strategy",
  "Financials unrealistic",
  "Too complex for this deal",
]
